<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Movimentos
            <el-button icon="fa fa-download"
              :loading="btnLoading"
              style="font-size: 1em; float: right;"
              @click="report()"
              circle></el-button>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
            <div class="col-sm-12">
              <label class="col-sm-6">Produtos</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="produto"
              >
                <el-option
                  v-for="option in products"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Tipo</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="tipo"
              >
                <el-option
                  v-for="tipo in movimentos"
                  class="select-danger"
                  :value="tipo.value"
                  :label="tipo.label"
                  :key="tipo.id"
                ></el-option>
              </el-select>
            </div>
            <div style="margin-top: 15px; margin-left: 30px">
              <fg-input name="payment" label="Remotamente?" v-if="tipo === 'S'">
                <div>
                  <l-switch v-model="searcheRemote"></l-switch>
                </div>
              </fg-input>
            </div>

            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Maquina ou Locker</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="vendMachine"
              >
                <el-option
                  v-for="maq in machines"
                  class="select-danger"
                  :value="maq.id"
                  :label="maq.location"
                  :key="maq.id"
                ></el-option>
              </el-select>
            </div>
            <div class="col-sm-11" style="margin-top: 10px">
              <label class="col-sm-6">Periodo</label>
              <el-date-picker
                style="margin-left: 15px"
                v-model="date_init"
                type="daterange"
                format="dd/MM/yyyy"
                align="right"
                unlink-panels
                range-separator="a"
                start-placeholder="Data de início"
                end-placeholder="Data final">
              </el-date-picker>
            </div>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
            <el-table-column label="Tipo" property="movement_type" sortable="custom" />
            <el-table-column label="Máquina" property="vm_type" width="100" />
            <el-table-column label="Produto" property="product" sortable="custom" />
            <el-table-column label="Local" property="vm_location" sortable="custom" />
            <el-table-column label="Mola/Box" property="coil" min-width="50"/>
            <el-table-column label="Quantidade" property="amount" min-width="70"  sortable="custom"/>
            <el-table-column label="Data" property="created" sortable="custom"/>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Loading
} from "element-ui";
import swal from "sweetalert2";
import { Switch as LSwitch } from "src/components/index";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    LSwitch
  },
    data () {
      return {
        filtro: false,
        produto: [],
        tipo: [],
        prateleira: [],
        vendMachine: [],
        date_init: [],
        movements: [],
        products: [],
        machines: [],
        showTable: true,
        movementsAPI: [],
        totalResults: 30,
        pesquisa: '',
        searcheRemote: false,
        page: 1,
        pageSize: 10,
        order: false,
        loading: true,
        btnLoading: false,
        sord: '',
      }
    },
    mounted () {
      this.getListCompany()
    },
  computed: {
    tableData() {
      let movements = this.movements;
      let products = this.products;
      let machines = this.machines;
      let dateConverted = movements.map(v => {
        let  vm_type
        const d = new Date(v.created);
        const created = d.toLocaleString("pt-BR");
        v.shelf += 1;
        v.product = products.find(obj => {
          return obj.id === v.product;
        });
        if (v.product) {
          v.product = v.product.name;
        }
        if (v.vm_type == 1) {
          vm_type = 'Locker'
        }
        if (v.vm_type == 0) {
          vm_type = 'VM'
        }
        v.vm = machines.find(obj => {
          return obj.id === v.vm;
        });
        if (v.movement_type === "E") {
          v.movement_type = "Entrada";
        }
        if (v.movement_type === "S") {
          v.movement_type = "Saída";
        }
        if (v.remote) {
          v.movement_type = "Remoto";
        }
        return { ...v, created, vm_type };
      });
      return dateConverted;
    },
    productsName() {
      return this.$store.state.products.products;
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    },
    movimentos() {
      return [{ value: "E", label: "Entrada" }, { value: "S", label: "Saida" }];
    },
    shelf() {
      var seenNumber = {};

      var fil = this.$store.state.movements.movements.filter(function(
        currentObject
      ) {
        if (currentObject.shelf in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.shelf] = true;
          return true;
        }
      });
      return fil;
    },
  },
  created() {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === 'vm_location') {
        x.prop = 'vm__location'
      }
      if (x.prop === 'product') {
        x.prop = 'product__name'
      }
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    filtragem () {
      this.movements = this.movementsAPI
      var date = []
      this.pesquisa = ''

      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + '&company=' + ciaID
      }
      if (this.produto) {
        this.pesquisa = this.pesquisa + '&product=' + this.produto
      }
      if (this.tipo) {
        this.pesquisa = this.pesquisa + "&movement_type=" + this.tipo
      }
      if (this.vendMachine) {
        this.pesquisa = this.pesquisa + "&vm=" + this.vendMachine
      }
      if (this.searcheRemote && this.tipo === 'S') {
        this.pesquisa = this.pesquisa + '&remote=true'
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisa = this.pesquisa + '&created__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()
      this.filtro = false;
    },
    clearFiltro() {
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.produto = "";
      this.tipo = "";
      this.prateleira = "";
      this.vendMachine = "";
      this.filtro = false;
      this.searcheRemote = false,
      this.page = 1
      this.pesquisa = ''
      this.date_init = []
    },
    report() {
      if (this.totalResults > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResults + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        if (this.pesquisa == '') {
          const ciaID = localStorage.getItem('smartmachCiaID')
          if (ciaID) {
            this.pesquisa = this.pesquisa + "?company=" + ciaID
          }
        }
        this.pesquisa = this.pesquisa.replace('&','?')
        this.$store.dispatch('general/excelMovement', {search: this.pesquisa}).then(data => {
          this.btnLoading = data
        })
      }
    },
    getData (ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.loading = true
      this.$store.dispatch("products/listSort", {sort: '?company=' + ciaID}).then(resp => {
        this.products = resp
      }).catch(err => console.log(err));
      this.$store.dispatch("machines/listSort", {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
        this.machines = resp
      }).then(() =>{
        this.$store.dispatch("lockers/listSort", {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
          for (let index = 0; index < resp.length; index++) {
            this.machines.push(resp[index])
          }
          console.log('machines', this.machines)
        }).then (()=>{
          this.$store.dispatch("movements/listSort", {sort: '?page_size=' + this.pageSize
            + '&page=' + this.page + '&ordering=' + this.sord
            + '&company=' + ciaID + this.pesquisa}).then(resp => {
            this.totalResults = this.$store.state.movements.page.count
            this.movements = resp
            this.movementsAPI = resp
            this.loading = false
            console.log('total', this.totalResults)
            console.log('store', this.$store.state)
          }).catch(err => console.log(err))
        })
      })
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
